import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import axios from "axios";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

const CONTENT = {
  ko: {
    subject: "메가몰 도매 단가 정보 보호에 대한 협조 요청",
    body: [
      "항상 저희 메가몰을 이용해 주시는 파트너 여러분께 깊은 감사를 드립니다.",
      "당사는 고객님들께 보다 투명하고 경쟁력 있는 단가를 제공하기 위해 메가몰을 운영하고 있습니다.",
      "본 사이트 내의 모든 가격 및 프로모션 정보는 회원님들만을 위한 소중한 자산이며, 외부로 유출되거나 타 업체와의 협상 용도로 사용되는 것을 엄격히 금지하고 있습니다. 가격 정보 유출은 부득이하게 계정 이용 제한으로 이어질 수 있으니, 상호 신뢰를 바탕으로 한 파트너십이 유지될 수 있도록 정보 보호에 협조해 주시기를 간곡히 부탁드립니다.",
    ],
    checkLabel: "안내사항을 확인하였으며, 가격 정보 보호에 동의합니다. (필수)",
    agreeBtn: "동의하기",
    confirmTitle: "동의 확인",
    confirmMsg: "가격 정보 보호에 동의하시겠습니까?",
    confirmBtn: "확인",
    cancelBtn: "취소",
  },
  en: {
    subject:
      "Request for Cooperation Regarding Megamall Pricing Confidentiality",
    body: [
      "Thank you for being a valued partner of Megamall.",
      "We operate this platform to provide our registered customers with transparent and competitive wholesale pricing.",
      "Please note that all pricing and promotional information on this site is an exclusive asset for our members. Sharing this information externally or using it to negotiate with other vendors is strictly prohibited. As price leaks may inevitably lead to account restrictions, we kindly ask for your cooperation in protecting this information so we can maintain a mutually beneficial partnership.",
    ],
    checkLabel:
      "I acknowledge this notice and agree to keep the pricing information confidential. (Required)",
    agreeBtn: "Agree",
    confirmTitle: "Confirm Agreement",
    confirmMsg: "Do you agree to keep the pricing information confidential?",
    confirmBtn: "Confirm",
    cancelBtn: "Cancel",
  },
};

function SecurityConsentModal({ isOpen, onConsent }) {
  const [lang, setLang] = useState("ko");
  const [checked, setChecked] = useState(false);
  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const c = CONTENT[lang];

  const handleAgree = () => {
    if (!checked) return;
    setStep(2);
  };

  const handleConfirm = async () => {
    try {
      setIsSubmitting(true);
      const info = cookies.get("info");
      await axios.put(
        `${process.env.REACT_APP_WHOLESALE_API_URL}/company/security-consent`,
        { lang },
        {
          headers: {
            Authorization: info.token,
          },
        },
      );
      onConsent();
    } catch (error) {
      console.error("동의 저장 실패", error);
      alert("동의 처리 중 오류가 발생했습니다. 다시 시도해주세요.");
      setStep(1);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      {step === 1 ? (
        <>
          <ModalHeader>
            <div className="d-flex align-items-center justify-content-between w-100 pe-3">
              <span>메가몰 제품정보 보안 준수 동의</span>
              <div>
                <Button
                  size="sm"
                  color={lang === "ko" ? "primary" : "outline-secondary"}
                  onClick={() => setLang("ko")}
                  className="me-1"
                >
                  KO
                </Button>
                <Button
                  size="sm"
                  color={lang === "en" ? "primary" : "outline-secondary"}
                  onClick={() => setLang("en")}
                >
                  EN
                </Button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <p className="fw-bold text-secondary mb-3">{c.subject}</p>
            {c.body.map((paragraph, idx) => (
              <p key={idx}>{paragraph}</p>
            ))}
            <hr />
            <FormGroup check className="mt-3">
              <Input
                type="checkbox"
                id="consentCheck"
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />
              <Label check for="consentCheck" className="fw-bold">
                {c.checkLabel}
              </Label>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleAgree} disabled={!checked}>
              {c.agreeBtn}
            </Button>
          </ModalFooter>
        </>
      ) : (
        <>
          <ModalHeader>{c.confirmTitle}</ModalHeader>
          <ModalBody>
            <p className="mb-0">{c.confirmMsg}</p>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => setStep(1)}
              disabled={isSubmitting}
            >
              {c.cancelBtn}
            </Button>
            <Button
              color="primary"
              onClick={handleConfirm}
              disabled={isSubmitting}
            >
              {c.confirmBtn}
            </Button>
          </ModalFooter>
        </>
      )}
    </Modal>
  );
}

export default SecurityConsentModal;
